import { saveSubItem, loadSubItem } from 'app/common/helpers/storage';
import { get } from 'app/common/helpers/fetch';
import {
  SUBNAV_STORAGE,
  DESKTOP_CATEGORIES_STORAGE,
} from 'app/common/constants/storage-keys';
import { CACHE_DURATION_HOUR } from 'app/common/constants/caching';
import { getUtmParams } from 'app/common/helpers/utm_params';

function hasValidCacheData(cachedData) {
  return (
    cachedData &&
    cachedData.hasOwnProperty('flyouts') &&
    cachedData.hasOwnProperty('primary') &&
    cachedData.hasOwnProperty('cards')
  );
}

function transformCards(cards) {
  return cards.reduce(
    (acc, card) =>
      Object.assign(acc, {
        [card.group]: card,
      }),
    {}
  );
}

function getSubnavCacheKey(division) {
  return `${division}:${Groupon.App.name}`;
}

/** Fetch primary & subnav from server */
function fetchNavigation(division, utmparams, isRedesign) {
  const url = `/layout/api/v2/subnav`;
  const params = {};
  if (isRedesign) {
    params.isRedesign = true;
  }

  // load from server
  return get(`${url}?${utmparams.toString()}`, params).then(
    ({ flyouts, primary, categories, cards, divisionData }) => {
      const noFlyouts = !flyouts || !Object.keys(flyouts).length;
      const noCards = !Array.isArray(cards);

      if (noFlyouts) flyouts = {}; // just return an empty object
      if (noCards) cards = []; // just return an empty array

      if (!(noFlyouts || noCards)) {
        // save to local storage
        const storageKey = isRedesign
          ? DESKTOP_CATEGORIES_STORAGE
          : SUBNAV_STORAGE;
        saveSubItem(
          storageKey,
          getSubnavCacheKey(division),
          { flyouts, primary, cards, divisionData, categories },
          CACHE_DURATION_HOUR
        );
      }

      const transformedCards = transformCards(cards);
      return {
        flyouts,
        primary,
        cards: transformedCards,
        divisionData,
        categories,
      };
    }
  );
}

/**
 * Load subnav flyouts and cards from localstorage or server
 *
 * @param {string} division - location from reducer
 * @param {Boolean} isRedesign
 * @return {Promise}
 */
export function loadNavigationData(division, isRedesign = false) {
  // load local storage first
  const storageKey = isRedesign ? DESKTOP_CATEGORIES_STORAGE : SUBNAV_STORAGE;
  const cachedData = loadSubItem(storageKey, getSubnavCacheKey(division));
  const utm_params = getUtmParams();

  // if we got data from local storage, just return it
  if (hasValidCacheData(cachedData)) {
    return Promise.resolve({
      ...cachedData,
      cards: transformCards(cachedData.cards),
    });
  }

  // fetch data from server
  return fetchNavigation(division, utm_params, isRedesign);
}
